import axios from 'axios';
import config from './config';
import _ from "lodash";
const appAxios = axios.create({
    baseURL: config.externalAppsUrl,
});


class ExternalAppClient {
  constructor() {
    this._promisses = {};
    this._promissesCount = 0;
    this._abortController = new AbortController();

    const portRange = _.isInteger(config.externalAppsPortRange) && config.externalAppsPortRange > 0 ? config.externalAppsPortRange : 1

    this._baseUrls = [];
    if (_.isInteger(config.externalAppsPortStart) && config.externalAppsPortStart >= 0) {
      for (let i = 0; i < portRange; i++) {
        this._baseUrls.push(config.externalAppsUrl.replaceAll("{port}", `${config.externalAppsPortStart + i}`));
      }
    } else {
      this._baseUrls.push(config.externalAppsUrl)
    }
  }

  async _getExtApps(baseURL) {
    return new Promise((resolve, reject) => {
      const done = (result) => {
        delete this._promisses[baseURL];
        this._promissesCount = Object.keys(this._promisses).length
        resolve(result);
      };
      appAxios.get("", {
          baseURL: baseURL,
          signal: this._abortController.signal
        })
        .then(function(response) {
          if (response.status === 200) {
            done({ data: response.data, keys: Object.keys(response.data) });
          } else {
            done({ data: {}, keys: [] });
          }
        })
        .catch(function(error) {
          done(error);
        });
    });
  };

  async getExternalApps() {
    _.forEach(this._baseUrls, (baseUrl) => {
      this._promisses[baseUrl] = this._getExtApps(baseUrl);
    });

    this._promissesCount = Object.keys(this._promisses).length;
    let cnt = this._promissesCount;
    while (this._promissesCount > 0 && cnt > 0) {
      try {
        let res = await Promise.any(Object.values(this._promisses));
        if (res instanceof Error) {
          // just an error: do nothing
        } else {
          // grab first successfull result and stop others
          if (res && res.keys && res.keys.length > 1) {
            this._abortController.abort();
            return res;
          }
        }
      } catch (error) {
        console.error(error);
        break;
      }

    }

    return {
      data: {},
      keys: []
    };
  }

  async _openApp(baseURL, value, data) {
    return new Promise((resolve, reject) => {
      const done = (result) => {
        delete this._promisses[baseURL];
        this._promissesCount = Object.keys(this._promisses).length;
        resolve(result);
      };
      appAxios.post(`/${value}`, data, {
          baseURL: baseURL,
          signal: this._abortController.signal,
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(function(response) {
          done(response);
        })
        .catch(function(error) {
          done(error);
        });
    });
  }

  async openApp(value, data) {
    _.forEach(this._baseUrls, (baseUrl) => {
      this._promisses[baseUrl] = this._openApp(baseUrl, value, data);
    });

    this._promissesCount = Object.keys(this._promisses).length;
    while (this._promissesCount > 0) {
      try {
        let res = await Promise.any(Object.values(this._promisses));
        if (res instanceof Error) {
          // just an error: do nothing
        } else {
          // grab first successfull result and stop others
          if (res && res.data) {
            this._abortController.abort();
            return res;
          }
        }
      } catch (error) {
        console.error(error);
        break
      }

    }

    return null;
  }
}

class ApiExternalApp {
    static async getExternalApps() {
        return new Promise(function (resolve, reject) {
            const extAppClient = new ExternalAppClient();
            extAppClient.getExternalApps().then(result => {
                resolve(result);
            })
            .catch(function (error) {
                reject(error);
            });
        });
    }

    static openApp(value , data) {
        return new Promise(async function (resolve, reject) {
            const extAppClient = new ExternalAppClient();
            extAppClient.openApp(value , data).then(result => {
                resolve(result);
            })
            .catch(function (error) {
                reject(error);
            });
        });
    }
}
export default ApiExternalApp;